module.exports = {
    "index": {
        "login": "会員ランキング",
        "regist": "新規ユーザーへのギフト",
        "user": "新チーム",
        "jiang": "メンバー",
        "set": "備考",
        "lingqyu": "コメントが入力されていません。設定してください",
        "liji": "IFSCが入力されていません。設定してください",
        "list": {
            "0": "入金時間",
            "1": "デビットカード情報",
            "2": "注: Bitcoin ウォレット、USDT ウォレットの再チャージ。保証金の10%無料+手数料20ドル",
            "3": "買えなかったのは残念です。これからも購入してください。",
            "4": "ドル",
            "5": "初日の注文数が20に達し、これ以上の注文は受け付けられません",
            "6": "今すぐ送信"
        },
        "xuanchaun": {
            "xiazai": {
                "0": "銀行口座",
                "1": "注文をキャンセルする"
            },
            "tianjia": {
                "0": "住所",
                "1": "住所が入力されていません。設定してください"
            },
            "tiqu": {
                "0": "入力してください",
                "1": "アカウント残高が200未満です。再チャージして注文を受け取ってください。"
            }
        },
        "guanyu": {
            "title1": "口座残高をご確認ください",
            "text1": "口座残高が不足しています",
            "title2": "注文は処理されました。ページを更新してください。",
            "text2": "パラメータエラーです。注文番号を確認してください"
        },
        "title_content": {
            "0": "注文番号が存在しません",
            "1": "注文は失敗しました。このカテゴリーでは価格帯が不十分です。",
            "2": "注文に失敗しました。しばらくしてからもう一度お試しください。"
        },
        "content": {
            "0": "注文を無事受け取りました",
            "1": "注文残高が不足しています。再度注文を行ってください。",
            "2": "掴む"
        },
        "dugengduo": "会員残高が不足しています",
        "darkgrey": {
            "1": {
                "title": "注文は終了しました",
                "text": "チェックイン時間"
            },
            "2": {
                "title": "赤い封筒をゲット",
                "text": "リチャージへ進む"
            },
            "3": {
                "title": "もう一度見てみましょう",
                "text": "ロックを解除するには、アカウント残高が200以上である必要があります"
            },
            "4": {
                "title": "次のステップ",
                "text": "検証コード"
            },
            "5": {
                "title": "認証コードを入力してください",
                "text": "グラフィック認証コードの認証に失敗しました。再度入力してください"
            },
            "6": {
                "title": "リクエストが成功しました",
                "text": "携帯電話番号の形式が正しくありません"
            }
        },
        "into": {
            "yibiaoban": "アカウントが存在しません",
            "nihao": "ユーザーが存在しません",
            "yue": "ユーザーが非アクティブ化されました",
            "shebeigong": "このアカウントは他の場所でログインされています",
            "riqi": "パスワードを連続して何度も間違って入力しました。",
            "gaishu": "数分後にもう一度お試しください",
            "kaicaizong": "パスワードが間違っています",
            "xiaoshili": "ログインに成功しました",
            "rili": "認証コードが存在しません",
            "zhouli": "認証コードエラー",
            "yeli": "認証コードの有効期限が切れました",
            "tuilian": "招待コードが存在しません",
            "hezuo": "推奨ユーザーは無効になっています",
            "fukuanxin": "エラーリクエスト",
            "tianjiadi": "まずはログインしてください",
            "gengxin": "このアカウントは無効になっています",
            "yibiaoti": "アカウントの取引機能は凍結されました",
            "yaoqing": "このアカウントには未完了の注文があり、注文の取得を続行できません",
            "yaoqingren": "残高が",
            "shijian": "取引を続行できません",
            "choujiangci": "メンバーレベルの取引が不十分",
            "choujianggai": "興味宝物",
            "tuijianren": "満期前に資金を引き出すと、収入は得られず、手数料は",
            "xiejie": "この商品の最低投資額",
            "jiriqi": "この商品の最大投資額",
            "dianjifu": "異常なデータ",
            "tishi": {
                "1": "利用可能な残高が不足しています",
                "2": "操作は成功しました",
                "3": "操作に失敗しました!口座残高をご確認ください"
            },
            "chongzhijin": "投資開始",
            "chongzhigai": "操作する",
            "nindeyu": "利息残高振替",
            "mianchong": "繰り返し操作",
            "mianchongci": "利息残高の振替",
            "chongzhili": {
                "title": "パラメータエラー",
                "jine": "禁止",
                "shijian": "現在の操作を期間外に実行する",
                "zhauntai": "チャージ金額は以下より少なくすることはできません"
            },
            "yijiangli": "再充電は以下を超えることはできません",
            "yiqizhuan": "画像フォーマットエラー",
            "jianglili": "送信に失敗しました。しばらくしてからもう一度お試しください。",
            "shezhi": "微信ペイ",
            "mimashe": "Alipay決済",
            "dangqianmishu": "WeChat撤退",
            "xinmi": "アリペイの引き出し",
            "shuxinmi": "銀行カード情報はまだ追加されていません",
            "quemi": "取引パスワードが設定されていません",
            "shuquemi": "各会員レベルの引き出し限度額は",
            "dainyou": "現在のレベルの引き出しを完了する必要があります",
            "dianyoudi": "注文",
            "shudainyou": "残高不足",
            "fukuanshe": "会員レベルでは本日の引き出し回数が不足しています",
            "bitedi": "アカウント名義は必須です",
            "shugukuan": "口座名義人の最大文字数は30文字です",
            "jisheng": "銀行名は必須です",
            "qiangou": "銀行カード番号が必要です",
            "xiacixiaoshi": "携帯電話番号が必要です",
            "yingjian": "銀行カード番号はすでに存在します",
            "zonggong": "操作に失敗しました",
            "maidian": "ページが存在しません",
            "yingjiancheng": "割引を受ける",
            "zhuanzhang": "ログインしていないユーザー",
            "dianfeizong": "繰り返し送信しないでください",
            "zhuanzhangti": "成功を手に入れる",
            "zhaunzhangfeiyong": "失敗",
            "zuidifei": "成功",
            "tikuanjin": "この名前と銀行カードは別のアカウントにリンクされています",
            "zuidixian": "設定された配送先住所を削除できません",
            "bijieshou": "ログインパスワードが間違っています",
            "quezhi": "今日サインインしました",
            "querenti": "サインインに成功し、赤い封筒を受け取りました",
            "yiwen": "サインインに成功しました",
            "tili": "すべての出金注文",
            "yaohaoyou": "検証を通じて",
            "yaohuoci": "注文を受け取るにはログインしてください",
            "yihanwei": "注文を取得できませんでした。しばらくしてからもう一度お試しください。",
            "gongxihuo": "注文を取得できませんでした。商品在庫が不足しています"
        },
        "taocan": {
            "title": "携帯電話番号はすでに登録されています",
            "text": "1分以内に送信できるSMSは1通のみです",
            "kuanggong": "送信に成功しました",
            "liliang": "送信に失敗しました",
            "jiage": "SMS が正常に送信されました",
            "yingli": "不完全なパラメータ"
        },
        "baoming": {
            "title": "サーバースペースがそれをサポートしていません。 curl または fsocket がサポートされていることを確認してください。問題を解決するか、スペースを変更するには、ホスティング プロバイダーにお問い合わせください。",
            "text": "アカウントの有効期限が切れました"
        }
    },
    "login": {
        "yongdeng": "IPアドレス制限",
        "quedeng": "コンテンツにはセンシティブな言葉が含まれています",
        "yonghu": "製品パラメータが異常です",
        "mima": "利用可能な残高が不足しています。まずチャージしてください",
        "xieyi": "本日の金額",
        "tiaokaun": "今日のユーザー数",
        "tongyi": "今日のオンライン人数",
        "wangmi": "年",
        "zhaomi": "月",
        "zhaomiti": "サインイン",
        "feihuiyuan": "連続した",
        "lizhi": "今日サインインして赤い封筒を1枚受け取りました",
        "chaunghu": "日",
        "yonghumming": "一",
        "mimafu": "二",
        "zhanghaoyou": "四",
        "jinggao": "五"
    },
    "botton": {
        "lianjie": {
            "0": "六",
            "1": "サインイン",
            "2": "今日はすでにサインインしています",
            "3": "転出"
        },
        "zhichi": {
            "0": "転入",
            "1": "モール"
        }
    },
    "content": {
        "zhichu": "1つ",
        "jiage": "二流",
        "yinliang": "権限がありません",
        "jiaoyizhe": "メッセージの設定",
        "btbjiage": "$",
        "queren": "100",
        "quxiao": "300",
        "shehe": {
            "0": "500",
            "1": "1000",
            "2": "3000"
        }
    },
    "buchong": {
        "caidan": "5000",
        "dengchu": "10000",
        "shangdian": "30000",
        "dan": "1日で1つのアカウントが奪われる可能性がある",
        "choujiang": "発電委員会",
        "jiangli": "レベル1",
        "chongzhi": "三世代委員会",
        "zhuanzhang": "レベル3",
        "yongjin": "支払いのスクリーンショットをアップロード",
        "lijikaishi": "更新するには上に引き上げてください",
        "mianfei": "次のレベルの独占チャンネルはより高い手数料を得ることができます",
        "kaishi": "下に引いて更新",
        "lianjie": "従属リベート",
        "zhoumo": "空にすることはできません",
        "shizhi": "専用のカスタマーサービス",
        "jiaoyi": "2回入力したパスワードが一致しません",
        "zhichi": "2回入力されたファンドパスワードが一致しません",
        "fuzhi": "個人情報",
        "dangqian": "注文のマッチングなどのプラットフォーム監視を防止するため",
        "wanshan": "取引パスワードを確認してください",
        "buyizhi": "購入者メッセージ",
        "ziyou": "学ぶ",
        "mai": "第二世代の委託",
        "yaoqing": "レベル2",
        "yihan": "QR 画像コード",
        "gongxi": "取引パスワード管理",
        "huifu": "取引の詳細"
    },
    "tanchuang": {
        "one": "今日獲得した注文数",
        "two": "今日は手数料が取られた",
        "title1": "今日の結果",
        "title2": "今日の収益"
    },
    "weishangxian": {
        "weishangxian": "上記の操作は完了しました。ポイントを増やすにはカスタマーサービスにお問い合わせください。",
        "yueshouru": "価格",
        "meiyuan": "その他のタスク",
        "qianggouzhong": "ミッションホール",
        "chongzhidizhi": "タスクリベート",
        "jine": "クーポン",
        "bufu": "会員資格は永久です",
        "zhengque": "会員レベル",
        "xuanxiang": "会員詳細",
        "chongzhi": "Yu'ebaoの入出金記録",
        "xiaoshi": "余額宝収入",
        "yongjiu": "余額宝送金",
        "yongjin": "余額宝の送金",
        "renshu": "ユエバオ",
        "hezuo": "残金支払い",
        "fenxiang": "残高移行",
        "chenggong": "バランス",
        "tuijianID": "こんにちは、あなたの権利を保護するために、の正しいカード番号と支店情報をバインドしてください。情報が間違って記入され、お金が入金されなかった場合、このプラットフォームは一切の責任を負いません！このプラットフォームは、4大銀行以外の銀行からの引き出しには対応していません。",
        "neirong": "コミッションボーナス",
        "tuijian": "手数料率"
    },
    "into_one": {
		"daizhifu": "再チャージ注文 支払い待ち",
        "yibiaoban": "手数料",
        "nihao": "QRコードをローカルコンピュータに保存してスキャンします",
        "yue": "保存に成功しました",
        "shebeigong": "スクリーンショットを保存し、コードをスキャンして支払います",
        "riqi": "情報発表",
        "gaishu": "名前を変更する",
        "kaicaizong": "パスワードを変更する",
        "xiaoshili": "変更に成功しました",
        "rili": "元",
        "zhouli": "充電中",
        "yeli": "チャージ中です。後で残高を更新してください",
        "tuilian": "リチャージアップグレード",
        "hezuo": "再充電ステータス",
        "fukuanxin": "アップグレードのロック解除",
        "tianjiadi": "チャージしてロックを解除",
        "gengxin": "再チャージ注文の支払い待ち",
        "yibiaoti": "再充電記録",
        "yaoqing": "再充電手順",
        "yaoqingren": "チャージについてはカスタマーサービスにお問い合わせください",
        "shijian": "チャージ金額",
        "choujiangci": "補充する",
        "choujianggai": "再チャージ。引き出し",
        "tuijianren": "無料でサインアップ",
        "xiejie": "注文獲得に向けて全力を尽くしております。結果は下記にて発表させていただきます。",
        "jiriqi": "すべての製品",
        "dianjifu": "すべて撤回",
        "tishi": {
            "1": "全て",
            "2": "凍結",
            "3": "注文が数分以内に確認されない場合、システムは注文金額を凍結します。"
        },
        "chongzhijin": "ポイント",
        "chongzhigai": "消去",
        "nindeyu": "入金時間: 5分",
        "mianchong": "利用可能な残りの資産",
        "mianchongci": "読み込み中",
        "chongzhili": {
            "title": "アップグレードに成功しました",
            "jine": "アップロードへ進む",
            "shijian": "注文を取りに行きましょう",
            "zhauntai": "追加へ進む"
        },
        "yijiangli": "認証コードを送信",
        "yiqizhuan": "キャンセル",
        "jianglili": "引き出し可能残高",
        "shezhi": "利用可能残高",
        "mimashe": "条約",
        "dangqianmishu": "条約",
        "xinmi": "名前",
        "shuxinmi": "タイムアウト状態に入った後",
        "quemi": "商品",
        "shuquemi": "モールホーム",
        "dainyou": "ホームに戻る",
        "dianyoudi": "チーム規模",
        "shudainyou": "チームバランス",
        "fukuanshe": "チームコミッションステータス",
        "bitedi": "チーム総手数料",
        "shugukuan": "チーム全体の再充電",
        "jisheng": "チーム総撤退",
        "qiangou": "チームオーダー手数料",
        "xiacixiaoshi": "チームレポート",
        "yingjian": "チームフロー",
        "zonggong": "チーム管理",
        "maidian": "チーム",
        "yingjiancheng": "ブラウザで開く",
        "zhuanzhang": "オンライン決済",
        "dianfeizong": "エリア",
        "zhuanzhangti": "コピー成功",
        "zhaunzhangfeiyong": "リンクをコピー",
        "zuidifei": "クローン",
        "tikuanjin": "空",
        "zuidixian": "アバター設定",
        "bijieshou": "アバター",
        "quezhi": "問題が発生してサポートが必要な場合は、オンラインカスタマーサービスにお問い合わせください。",
        "querenti": "名前",
        "yiwen": "金額を節約する",
        "tili": "入金額がシステム要件を満たしていません",
        "yaohaoyou": "預入金額",
        "yaohuoci": "アクセス記録",
        "yihanwei": "フォーミュラ保証",
        "gongxihuo": "公式提供"
    },
    "into_two": {
        "yibiaoban": "定期的な財務管理",
        "nihao": "確かに",
        "yue": "監査失敗",
        "shebeigong": "承認された",
        "riqi": "カスタマーサービスセンター",
        "gaishu": "顧客サービス",
        "kaicaizong": "ネットワーク",
        "xiaoshili": "パスワード管理",
        "rili": "ユーザーの皆様、資金の安全を確保するため、実名を登録し、出金パスワードを設定してください。お名前が口座名と一致しない場合、出金できません。",
        "zhouli": "小数点が必要です",
        "yeli": "有効期限が切れると、システムは自動的に解凍されます",
        "tuilian": "左右にスワイプして詳細をご覧ください",
        "hezuo": "送信済み",
        "fukuanxin": "完了",
        "tianjiadi": "取り消されました",
        "gengxin": "メールアドレスを入力してください",
        "yibiaoti": "メールアドレスを入力してください",
        "yaoqing": "すでにアカウントをお持ちですか? 今すぐダウンロード",
        "yaoqingren": "期限切れ",
        "shijian": "合格した",
        "choujiangci": "拒否",
        "choujianggai": "富への道を歩み始めましょう",
        "tuijianren": "口座開設者",
        "xiejie": "口座開設契約",
        "jiriqi": "アカウント名",
        "dianjifu": "口座開設住所",
        "tishi": {
            "1": "銀行",
            "2": "銀行口座",
            "3": "今日の収入"
        },
        "chongzhijin": "支払い保留中",
        "chongzhigai": "保留中",
        "nindeyu": "審査待ち",
        "mianchong": "お支払い",
        "mianchongci": "受領待ち",
        "chongzhili": {
            "title": "ロック解除するには",
            "jine": "WeChatはQRコードを直接長押しして識別することができます",
            "shijian": "パスワードを忘れた",
            "zhauntai": "迅速な撤退"
        },
        "yijiangli": "総充電量",
        "yiqizhuan": "総引き出し額",
        "jianglili": "総収入",
        "shezhi": "総資産",
        "mimashe": "残高",
        "dangqianmishu": "ご注文は",
        "xinmi": "ご注文は凍結されています。しばらくお待ちください。",
        "shuxinmi": "ご注文は期限切れのため、処理できません。",
        "quemi": "あなたの個人情報",
        "shuquemi": "銀行カード情報",
        "dainyou": "このアドレスを削除してもよろしいですか?",
        "dianyoudi": "銀行カード情報をまだ追加していません",
        "shudainyou": "サービス契約に同意しました",
        "fukuanshe": "支払いが完了しました",
        "bitedi": "分かっていますし、同意します",
        "shugukuan": "私の残高",
        "jisheng": "私のチーム",
        "qiangou": "私の総資産",
        "xiacixiaoshi": "私の携帯電話番号",
        "yingjian": "私の注文",
        "zonggong": "私の財布",
        "maidian": "私のデビットカード",
        "yingjiancheng": "私の",
        "zhuanzhang": "スクリーンキャプチャまたは直接",
        "dianfeizong": "銀行",
        "zhuanzhangti": "すべての製品",
        "zhaunzhangfeiyong": "すべてのタイプ",
        "zuidifei": "携帯電話番号が間違っています",
        "tikuanjin": "電話番号の入力が間違っています",
        "zuidixian": "電話番号",
        "bijieshou": "電話番号",
        "quezhi": "携帯電話",
        "querenti": "手数料",
        "yiwen": "注文中",
        "tili": "注文の受け取り時間",
        "yaohaoyou": "注文番号",
        "yaohuoci": "注文獲得記録",
        "yihanwei": "記錄",
        "gongxihuo": "注文の受け取り手順"
    },
    "into_s1": {
        "yibiaoban": "注文を受け取る",
        "nihao": "注文数量",
        "yue": "注文割引",
        "shebeigong": "プロモーションポスター",
        "riqi": "推奨数",
        "gaishu": "おすすめ商品",
        "kaicaizong": "推薦する",
        "xiaoshili": "提出中",
        "rili": "送信が完了しました。審査までしばらくお待ちください。",
        "zhouli": "送信に成功しました。ジャンプします",
        "yeli": "注文を送信",
        "tuilian": "提出する",
        "hezuo": "引き出し回数",
        "fukuanxin": "撤退状況",
        "tianjiadi": "撤退申請が提出されました",
        "gengxin": "出金記録",
        "yibiaoti": "出金手数料",
        "yaoqing": "出金額",
        "yaoqingren": "出金限度額",
        "shijian": "撤退",
        "choujiangci": "検索",
        "choujianggai": "お支払い方法",
        "tuijianren": "支店住所",
        "xiejie": "受取人",
        "jiriqi": "受取人",
        "dianjifu": "所得基準",
        "tishi": {
            "1": "収入の種類",
            "2": "収益記録",
            "3": "人物の名前"
        },
        "chongzhijin": "配送先住所情報",
        "chongzhigai": "配送先住所の変更",
        "nindeyu": "收貨地址編輯",
        "mianchong": "配送先住所",
        "mianchongci": "受信者の身元情報",
        "chongzhili": {
            "title": "新しい人々",
            "jine": "新しいパスワード",
            "shijian": "新しい電話番号",
            "zhauntai": "時間"
        },
        "yijiangli": "昨日のチームコミッション",
        "yiqizhuan": "昨日の収益",
        "jianglili": "まだデータがありません",
        "shezhi": "まだ記録はありません",
        "mimashe": "詳細情報",
        "dangqianmishu": "もっと",
        "xinmi": "銀行カードがバインドされていません。バインドに進みます",
        "shuxinmi": "地域が入力されていません。設定してください",
        "quemi": "銀行口座が入力されていません。設定してください",
        "shuquemi": "支店住所が入力されていません。設定してください",
        "dainyou": "電話番号が入力されていません。設定してください",
        "dianyoudi": "未輸入電話，請設定",
        "shudainyou": "未輸入真實姓名，請設定",
        "fukuanshe": "未輸入詳細地址，請設定",
        "bitedi": "未輸入銀行カード番号，請設定",
        "shugukuan": "QQが入力されていません。設定してください",
        "jisheng": "このデータは以下から提供されています",
        "qiangou": "この引き出しは手数料から差し引かれます",
        "xiacixiaoshi": "読み込み中",
        "yingjian": "毎日注文を受け付けております",
        "zonggong": "QRコードはありません。クリックしてください",
        "maidian": "データなし",
        "yingjiancheng": "コンテンツはもうありません",
        "zhuanzhang": "これ以上のデータはありません",
        "dianfeizong": "記録なし",
        "zhuanzhangti": "登録時間",
        "zhaunzhangfeiyong": "登録する",
        "zuidifei": "注意：チャージ情報が多いため、チャージする前に必ず口座番号をよく確認してください。このプラットフォームは口座番号を随時変更します。ご不明な点がございましたら、オンラインカスタマーサービスをクリックしてください。",
        "tikuanjin": "アクティビティセンター",
        "zuidixian": "アクティブユーザー",
        "bijieshou": "配送先住所を追加",
        "quezhi": "親切なヒント",
        "querenti": "州",
        "yiwen": "ユーザーリチャージ",
        "tili": "ユーザー名は空欄にできません",
        "yaohaoyou": "ユーザー名が正しくありません。2～12 文字または数字でなければなりません。",
        "yaohuoci": "ユーザーの注文",
        "yihanwei": "ユーザーの退会",
        "gongxihuo": "電話番号"
    },
    "into_f": {
        "yibiaoban": "ログインパスワード",
        "nihao": "ログイン",
        "yue": "直接",
        "shebeigong": "直接",
        "riqi": "本名",
        "gaishu": "変更を確認する",
        "kaicaizong": "カードのバインドを確認する",
        "xiaoshili": "もちろん",
        "rili": "再チャージを確認",
        "zhouli": "本当にキャンセルしますか？キャンセルすると金額は凍結されます。",
        "yeli": "パスワードを認証する",
        "tuilian": "この金額を残高に引き出すことを確認しますか?満期前の引き出しには利息はかかりません！ 、そして差し引く",
        "hezuo": "本当に終了しますか?",
        "fukuanxin": "数秒で私のページに戻る",
        "tianjiadi": "2番",
        "gengxin": "すぐに現金を引き出す",
        "yibiaoti": "今すぐ購入",
        "yaoqing": "今すぐアップグレード",
        "yaoqingren": "今すぐ設定",
        "shijian": "購入者が受領を確認するのを待っています",
        "choujiangci": "購入者の確認を待っています",
        "choujianggai": "加盟店システムの応答を待っています",
        "tuijianren": "フィルター",
        "xiejie": "導入",
        "jiriqi": "システムアナウンス",
        "dianjifu": "このシステムはLBS技術に基づいており、クラウドを通じて製品を自動的にマッチングします。",
        "tishi": {
            "1": "システムアカウント",
            "2": "累計収入",
            "3": "オンラインチャージ"
        },
        "chongzhijin": "オフラインリチャージ",
        "chongzhigai": "携帯電話番号をバインドする",
        "nindeyu": "銀行カードをバインドする",
        "mianchong": "統計",
        "mianchongci": "配送先住所を編集",
        "chongzhili": {
            "title": "デビットカードを編集",
            "jine": "編集",
            "shijian": "ネットワークが安定していません。電波状況の良い場所で再度お試しください。",
            "zhauntai": "ネットワークが不安定です。電波のよい場所でもう一度お試しください。"
        },
        "yijiangli": "連絡先",
        "yiqizhuan": "注文を取りに行きましょう",
        "jianglili": "自動",
        "shezhi": "自動計算",
        "mimashe": "自営ショッピングモール",
        "dangqianmishu": "に",
        "xinmi": "認証コードを取得する",
        "shuxinmi": "ルール",
        "quemi": "ロック解除",
        "shuquemi": "注文番号",
        "dainyou": "注文は凍結されており、",
        "dianyoudi": "注文がタイムアウトしました",
        "shudainyou": "合計注文金額",
        "fukuanshe": "合計メモ",
        "bitedi": "メモ配達通知書",
        "shugukuan": "注文は正常に送信されました",
        "jisheng": "注文の詳細",
        "qiangou": "注文",
        "xiacixiaoshi": "パスワードを記憶する",
        "yingjian": "共通アドレスとして設定",
        "zonggong": "デフォルトとして設定",
        "maidian": "アバターを設定する",
        "yingjiancheng": "詳細",
        "zhuanzhang": "詳しい住所",
        "dianfeizong": "お支払い領収書をアップロードしてください",
        "zhuanzhangti": "チャージバウチャーをアップロードしてください",
        "zhaunzhangfeiyong": "お支払い情報をよくご確認ください",
        "zuidifei": "お支払いください",
        "tikuanjin": "名前を編集してください",
        "zuidixian": "チャージ時間に影響が出ないように、送金金額の小数点を必ず残してください。",
        "bijieshou": "チャージは以下の口座にお振込みください",
        "quezhi": "チャージ完了後、オンラインカスタマーサービスにご相談ください。",
        "querenti": "チャージ名を入力してください",
        "yiwen": "チャージ用の携帯電話番号を入力してください",
        "tili": "チャージ金額を入力してください",
        "yaohaoyou": "お名前を入力してください",
        "yaohuoci": "携帯電話番号を入力してください",
        "yihanwei": "有効な携帯電話番号を入力してください",
        "gongxihuo": "詳しい住所を入力してください"
    },
    "into_s": {
        "yibiaoban": "詳細な配送先住所を入力してください",
        "nihao": "パスワードを忘れないようにしてください。パスワードを忘れた場合は、カスタマーサービスにお問い合わせください。",
        "yue": "オンラインカスタマーサービスにお問い合わせください（プラットフォームは随時アカウントを変更します）",
        "shebeigong": "取引パスワードを入力してください",
        "riqi": "チャージ金額を入力してください",
        "gaishu": "元のパスワードを入力してください",
        "kaicaizong": "パスワードを入力してください",
        "xiaoshili": "口座名義人の名前を入力してください",
        "rili": "アカウント所有者の携帯電話番号を入力してください",
        "zhouli": "銀行の住所を入力してください",
        "yeli": "銀行口座を入力してください",
        "tuilian": "銀行口座を入力してください",
        "hezuo": "新しいパスワードを入力してください",
        "fukuanxin": "電話番号を入力してください",
        "tianjiadi": "モバイル認証コードを入力してください",
        "gengxin": "紹介コードを入力してください",
        "yibiaoti": "出金額を入力してください",
        "yaoqing": "受取人の名前を入力してください",
        "yaoqingren": "新しいパスワードを入力してください",
        "shijian": "電話番号またはメールアドレスを入力してください",
        "choujiangci": "ユーザー名を入力してください",
        "choujianggai": "ログインパスワードを入力してください",
        "tuijianren": "SMS認証コードを入力してください",
        "xiejie": "アカウント/パスワード/確認コードを入力してください",
        "jiriqi": "ファンドパスワードを入力してください",
        "dianjifu": "振込金額を入力してください",
        "tishi": {
            "1": "招待コードを入力してください",
            "2": "銀行カード番号を入力してください",
            "3": "認証コードを入力してください"
        },
        "chongzhijin": "お支払い方法を選択してください",
        "chongzhigai": "支払い方法を選択してください",
        "nindeyu": "配送先住所を選択してください",
        "mianchong": "アップグレードしたいレベルを選択してください",
        "mianchongci": "口座残高",
        "chongzhili": {
            "title": "口座凍結額",
            "jine": "アカウントの詳細",
            "shijian": "口座残高",
            "zhauntai": "購入収入"
        },
        "yijiangli": "購入時に本名を入力しなかった場合は設定してください",
        "yiqizhuan": "金融商品を購入する際、悪質な購入はリターンを計算せず、手数料を請求する",
        "jianglili": "買う",
        "shezhi": "ファンドパスワード",
        "mimashe": "リダイレクト",
        "dangqianmishu": "メッセージをコピーして、オンラインバンキングまたはAlipayで送金またはチャージを完了してください。",
        "xinmi": "チャージ金額を入力してください",
        "shuxinmi": "名前を入力してください",
        "quemi": "入金額を入力してください",
        "shuquemi": "電話番号を入力してください",
        "dainyou": "ファンドのパスワードを入力してください",
        "dianyoudi": "戻る",
        "shudainyou": "戻る",
        "fukuanshe": "新しい配送先住所は追加されていません",
        "bitedi": "銀行カードはまだ追加されていません",
        "shugukuan": "いろいろ見て回る",
        "jisheng": "リモートホストが割り当てています",
        "qiangou": "ログアウト",
        "xiacixiaoshi": "チャージ方法を選択",
        "yingjian": "出金方法を選択",
        "zonggong": "数量を選択",
        "maidian": "金融商品を選択する",
        "yingjiancheng": "友達を招待する",
        "zhuanzhang": "参加してさらなる特典を獲得しましょう",
        "dianfeizong": "招待コード",
        "zhuanzhangti": "招待リンク: クリックしてコピー",
        "zhaunzhangfeiyong": "お支払い情報をよくご確認ください",
        "zuidifei": "デビットカード引き出し",
        "tikuanjin": "デビットカード口座",
        "zuidixian": "銀行カード",
        "bijieshou": "銀行名",
        "quezhi": "質問",
        "querenti": "サポートが必要な場合は、カスタマーサービスに連絡して手動でチャージすることができます。",
        "yiwen": "支払う必要がある",
        "tili": "予想収益",
        "yaohaoyou": "推定収益",
        "yaohuoci": "初回入金回数",
        "yihanwei": "表紙",
        "gongxihuo": "今すぐチャージ"
    },
    "into_se": {
        "yibiaoban": "検証コード",
        "nihao": "デフォルト",
        "yue": "QR コードをスキャンするには、手動でスクリーンショットを撮り、ローカル コンピューターに保存してください。",
        "shebeigong": "手動で",
        "riqi": "Home",
        "gaishu": "PasswordLogin",
        "kaicaizong": "まだ提出しないでください",
        "xiaoshili": "登録完了",
        "rili": "アップグレード可能",
        "zhouli": "アップグレードできません",
        "yeli": "アップグレード条件が満たされていないため、アップグレードできません",
        "tuilian": "アップグレード基準に達し、アップグレードが完了しました",
        "hezuo": "システム通知",
        "fukuanxin": "ユーザー残高が不足しています",
        "tianjiadi": "招待されたユーザーが不足しています",
        "gengxin": "アップグレード条件が満たされていません",
        "yibiaoti": "口座残高は",
        "yaoqing": "招待する",
        "yaoqingren": "ロックを解除するには",
        "shijian": "ウォレットアドレス",
        "choujiangci": "ウォレット経由でスキャンして送金できます",
        "choujianggai": "本日のチームコミッション",
        "tuijianren": "アプリのダウンロード",
        "xiejie": "リチャージボーナス",
        "jiriqi": "TRC20アドレスを入力してください",
        "dianjifu": "ERC20アドレスを入力してください",
        "tishi": {
            "1": "私たちについて",
            "2": "エージェント",
            "3": "ルール"
        },
        "chongzhijin": "導入",
        "chongzhigai": "資格",
        "nindeyu": "ギフトボックスを開けるとサプライズ",
        "mianchong": "今すぐお金を稼ぐ",
        "mianchongci": "以前のパスワード",
        "chongzhili": {
            "title": "古いパスワードを入力してください",
            "jine": "パスワードをもう一度入力してください",
            "shijian": "パスワードが正常に変更されました",
            "zhauntai": "パスワードの変更に失敗しました"
        },
        "yijiangli": "同意するにはボックスにチェックを入れてください",
        "yiqizhuan": "アップグレード基準に達したため、自動的にアップグレードされました",
        "jianglili": "バランス変更によりダウングレード",
        "shezhi": "システム通知",
        "mimashe": "取引注文",
        "dangqianmishu": "システムにより支払いが強制されました。ご質問がある場合は、カスタマーサービスにお問い合わせください。",
        "xinmi": "自動注文取得を有効にする",
        "shuxinmi": "自動注文取得をオフにする",
        "quemi": "重複したユーザー名",
        "shuquemi": "バランス変更によりダウングレード",
        "dainyou": "アップグレード基準に達したため、自動的にアップグレードされました",
        "dianyoudi": "電話",
        "shudainyou": "私たちについて",
        "fukuanshe": "今すぐ見る",
        "bitedi": "プラットフォーム",
        "shugukuan": "発表",
        "jisheng": "友達を招待して現金をゲット",
        "chongxindenglu": "再度ログインしてください",
        "pingtaijianjie": "プラットフォームの紹介",
        "pingtaijianjie1": "注文獲得ルール",
        "pingtaijianjie2": "代理店協力",
        "pingtaijianjie3": "会社の資格"
    },
    "qing_sd": "お待ちください",
    "loading1": "接続エージェント",
    "loading2": "注文をリクエストする",
    "loading3": "注文中",
	goods:['グリーンガラス','高級スキンケア製品','食品グレードのプラスチックカップ','クラシック香水','クラシック香水','ディズニースタイルのクマ'], 
	tab_name:['表紙','注文履歴','注文する','顧客サービス','私の'],
	pingjia:'評価する',
	login_t1:'ワンストップでグローバルショッピングしてポイントを獲得',
	zhangh:'電話番号を入力してください',
	email:'Email',
	use_app:'Use App',
	index_t1:'Extra 30% Off + 10% Cashback + Free Shipping  on Your First App Purchase. T&Cs Apply',
	qianbao:'財布',
	huoqu_yj:"手数料を受け取る",
	zhangh_ye:'口座残高',
	zhangh_je:'口座残高',
	huoq_yj:'手数料を受け取る',
	dingd_s:'注文数量',
	caoz_bz:'手順',
	caoz_t1:'1、タスクの開始ボタンをクリックし、プロンプトに従ってタスクを完了します。',
	caoz_t2:'2、タスクを完了したら、手数料を残高に決済することができます',
	kefu_t1:'ご質問やご不明な点がございましたら，',
	kefu_t2:'問題を解決するには、オンラインカスタマーサービスにお問い合わせください。',
	kefu_t3:'あなただけの特別なカスタマーサービス',
	changj_wtjd:'よくある質問',
	changj_wt:[
		{name:'チャージ方法と利用可能な支払い方法?',value:' このシステムは複数の国で利用可能であり、国際的な支払い方法を提供しています。:USDT(ERC20)。同時に、さまざまな国の通貨もサポートしています。。'},
		{name:'どのように投資して収入を得ることができるか?',value:'システム内で商品取引に参加し、毎日安定した取引収入を得ることができます。すべての収益は銀行カードから引き出すことができます。'},
		{name:'会員登録方法?',value:'新規会員は招待により登録されます。登録会員の特典を確保し、過剰な登録による特典の減少を防ぐため、新規会員は既存会員の招待を受けてのみ登録できます。。'},
		{name:'購入金額に制限はありますか？?',value:'はい、より多くの会員が特典を得られるよう、システム内の各アカウントには最低購入額制限が設けられています。。'}
	],
	yonghu_m:'ユーザー名',
	shoukuan_zh:'受取口座',
	youxiang:'メール',
	zhanghao:'アカウント',
	xiugai_mima:'パスワードを変更する',
	xuanze_yy:'言語を選択',
	queren:'確認する',
	bangka:'支払い口座をバインドしてください',
	xingy_d:'おめでとうございます。幸運な注文を獲得しました',
	"nextrecharge": {
	    "a": "以下の口座にお振込みください",
	    "b": "入金時間: 5分",
	    "c": "銀行",
	    "d": "銀行カード番号",
		"e": "ウォレットアドレス",
		"f": "銀行カード番号",
		"g": "銀行カード番号",
		"h": "銀行カード番号",
		"i": "銀行カード番号",
		"j": "銀行カード番号",
		"k": "銀行カード番号",
		"l": "銀行カード番号",
		"m": "銀行カード番号",
		"n": "チャージ時間に影響が出ないように、送金金額の小数点を必ず残してください。",
		"o": "ヒント",
		"p": "1.メッセージをコピーして、オンラインバンキングまたはAlipayで送金と再チャージを完了してください。。",
		"q": "2.アプリのスクリーンショットを手動で撮るか、QRコードをローカルスキャンに直接保存してください。。",
		"r": "3.WeChatはQRコードを直接長押しして識別することができます。",
		"s": "4.上記の操作を完了したら、カスタマーサービスに連絡してポイントを増やしてください。。",
	},
}	